<template>
  <CModal alignment="center" :visible="show" @close="$emit('close')">
    <CModalHeader class="bg-primary">
      <CModalTitle class="text-light fs-6"
        >登入密碼修改 - {{ name }}</CModalTitle
      >
    </CModalHeader>
    <CModalBody>
      <div
        class="col-10 mx-auto d-flex justify-content-between align-items-center mt-5 mb-4"
      >
        <span class="me-5 text-primary">請輸入密碼</span>
        <div class="position-relative col-7 d-flex align-items-center">
          <input
            :type="passwordType"
            class="rounded-pill border info px-2"
            v-model="password"
          />
          <img
            class="show-password"
            :src="
              passwordType === 'text'
                ? require('@/assets/icons/open-eye.svg')
                : require('@/assets/icons/close-eye.svg')
            "
            :alt="passwordType === 'text' ? 'open-eye' : 'close-eye'"
            @click="
              passwordType = passwordType === 'password' ? 'text' : 'password'
            "
          />
        </div>
      </div>
      <div
        class="col-10 mx-auto d-flex justify-content-between align-items-center mb-5"
      >
        <span class="me-5 text-primary">請再次輸入密碼</span>

        <div class="position-relative col-7 d-flex align-items-center">
          <input
            class="rounded-pill border info col-7 px-2"
            v-model="passwordTwo"
            :type="passwordTwoType"
          />
          <img
            class="show-password"
            :src="
              passwordTwoType === 'text'
                ? require('@/assets/icons/open-eye.svg')
                : require('@/assets/icons/close-eye.svg')
            "
            :alt="passwordTwoType === 'text' ? 'open-eye' : 'close-eye'"
            @click="
              passwordTwoType =
                passwordTwoType === 'password' ? 'text' : 'password'
            "
          />
        </div>
      </div>
    </CModalBody>
    <CModalFooter>
      <CButton color="primary" @click="submit">確定</CButton>
      <CButton
        color="primary"
        variant="outline"
        class="text-primary"
        @click="$emit('close')"
        >取消</CButton
      >
    </CModalFooter>
  </CModal>
  <MsgBox :show="showMsgBox" :errorMsg="errorMsg" @close="showMsgBox = false" />
</template>
<script>
import { ref } from '@vue/reactivity'
import useInfo from '@/composables/useInfo'
import { useRoute } from 'vue-router'
import MsgBox from '@/components/MsgBox.vue'

export default {
  components: {
    MsgBox,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: '',
    },
  },
  emits: ['close'],
  setup(props, { emit }) {
    const route = useRoute()
    const { signEditPassword } = useInfo()
    const password = ref('')
    const passwordTwo = ref('')
    const errorCode = ref('')
    const showMsgBox = ref(false)
    const errorMsg = ref('')
    const passwordType = ref('password')
    const passwordTwoType = ref('password')
    const submit = async () => {
      const res = await signEditPassword({
        id: route.params.id,
        password: password.value,
        password2: passwordTwo.value,
      })
      if (res.error) {
        showMsgBox.value = true
        errorMsg.value = res.msg
        errorCode.value = res.error
        password.value = ''
        passwordTwo.value = ''
      } else {
        showMsgBox.value = true
        errorMsg.value = '修改成功'
      }
      emit('close')
    }

    return {
      password,
      passwordTwo,
      showMsgBox,
      submit,
      errorMsg,
      passwordType,
      passwordTwoType,
      errorCode,
    }
  },
}
</script>
<style lang="scss" scoped>
img {
  width: 15px;
  margin: 0 10px;
}
.content {
  background-color: #fff;
  border: 1px solid #bdbdbd;
  outline: none;
}
.remark-btn {
  font-size: 14px;
  color: #fff;
}
.options-box {
  height: 300px;
  overflow: scroll;
}
.show-password {
  position: absolute;
  right: 10px;
}
.info {
  width: 100%;
}
</style>
